module.exports = __webpack_public_path__ + "images/all-good-badge.0ee53abd770a6a459b351790686d277c.svg";